import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, Info } from 'lucide-react';

export const TermesConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-2 text-gray-300 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Retour au site</span>
          </button>
          <h1 className="text-4xl md:text-5xl font-bold">Termes et Conditions</h1>
          <p className="text-gray-300 mt-4">Conditions générales d'utilisation</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          
          {/* Définitions */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <FileText className="mr-3 text-blue-600" size={28} />
              Définitions
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>Client :</strong> tout professionnel ou personne physique capable au sens des articles 1123 et suivants du Code civil, ou personne morale, 
                qui visite le Site objet des présentes conditions générales.
              </p>
              <p>
                <strong>Prestations et Services :</strong> K&O PHONELAB met à disposition des Clients ses services de réparation d'appareils électroniques.
              </p>
              <p>
                <strong>Contenu :</strong> Ensemble des éléments constituants l'information présente sur le Site, notamment textes – images – vidéos.
              </p>
              <p>
                <strong>Informations clients :</strong> Ci après dénommé « Information (s) » qui correspondent à l'ensemble des données personnelles susceptibles d'être détenues 
                par K&O PHONELAB pour la gestion de votre compte, de la gestion de la relation client et à des fins d'analyses et de statistiques.
              </p>
              <p>
                <strong>Utilisateur :</strong> Internaute se connectant, utilisant le site susnommé.
              </p>
              <p>
                <strong>Informations personnelles :</strong> « Les informations qui permettent, sous quelque forme que ce soit, directement ou non, l'identification des personnes 
                physiques auxquelles elles s'appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).
              </p>
              <p className="text-sm italic">
                Les termes « données à caractère personnel », « personne concernée », « sous traitant » et « données sensibles » ont le sens défini par le 
                Règlement Général sur la Protection des Données (RGPD : n° 2016-679)
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <Info className="mr-3 text-blue-600" size={28} />
              9. Liens hypertextes, « cookies » et balises ("tags") internet
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le site contient un certain nombre de liens hypertextes vers d'autres sites, mis en place avec l'autorisation de K&O PHONELAB. 
                Cependant, K&O PHONELAB n'a pas la possibilité de vérifier le contenu des sites ainsi visités, et n'assumera en conséquence aucune responsabilité de ce fait.
              </p>
              <p>
                Sauf si vous décidez de désactiver les cookies, vous acceptez que le site puisse les utiliser. Vous pouvez à tout moment désactiver ces cookies 
                et ce gratuitement à partir des possibilités de désactivation qui vous sont offertes et rappelées ci-après, sachant que cela peut réduire ou empêcher 
                l'accessibilité à tout ou partie des Services proposés par le site.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Cookies détails */}
          <section>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              9.1. « COOKIES »
            </h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Un « cookie » est un petit fichier d'information envoyé sur le navigateur de l'Utilisateur et enregistré au sein du terminal de l'Utilisateur 
                (ex : ordinateur, smartphone), (ci-après « Cookies »). Ce fichier comprend des informations telles que le nom de domaine de l'Utilisateur, 
                le fournisseur d'accès Internet de l'Utilisateur, le système d'exploitation de l'Utilisateur, ainsi que la date et l'heure d'accès. 
                Les Cookies ne risquent en aucun cas d'endommager le terminal de l'Utilisateur.
              </p>
              <p>
                K&O PHONELAB est susceptible de traiter les informations de l'Utilisateur concernant sa visite du Site, telles que les pages consultées, les recherches effectuées. 
                Ces informations permettent à K&O PHONELAB d'améliorer le contenu du Site, de la navigation de l'Utilisateur.
              </p>
              <p>
                Les Cookies facilitant la navigation et/ou la fourniture des services proposés par le Site, l'Utilisateur peut configurer son navigateur pour qu'il lui permette 
                de décider s'il souhaite ou non les accepter de manière à ce que des Cookies soient enregistrés dans le terminal ou, au contraire, qu'ils soient rejetés, 
                soit systématiquement, soit selon leur émetteur.
              </p>
              <p>
                Si l'Utilisateur refuse l'enregistrement de Cookies dans son terminal ou son navigateur, ou si l'Utilisateur supprime ceux qui y sont enregistrés, 
                l'Utilisateur est informé que sa navigation et son expérience sur le Site peuvent être limitées.
              </p>
              <p>
                À tout moment, l'Utilisateur peut faire le choix d'exprimer et de modifier ses souhaits en matière de Cookies. K&O PHONELAB pourra en outre faire appel 
                aux services de prestataires externes pour l'aider à recueillir et traiter les informations décrites dans cette section.
              </p>
              <p>
                Enfin, en cliquant sur les icônes dédiées aux réseaux sociaux Twitter, Facebook, Linkedin et Google Plus figurant sur le Site de K&O PHONELAB ou dans son application mobile 
                et si l'Utilisateur a accepté le dépôt de cookies en poursuivant sa navigation sur le Site Internet ou l'application mobile de K&O PHONELAB, Twitter, Facebook, 
                Linkedin et Google Plus peuvent également déposer des cookies sur vos terminaux (ordinateur, tablette, téléphone portable).
              </p>
              <p>
                Ces types de cookies ne sont déposés sur vos terminaux qu'à condition que vous y consentiez, en continuant votre navigation sur le Site Internet ou l'application mobile 
                de K&O PHONELAB. À tout moment, l'Utilisateur peut néanmoins revenir sur son consentement à ce que K&O PHONELAB dépose ce type de cookies.
              </p>
            </div>
          </section>

          <hr className="border-gray-200" />

          {/* Balises internet */}
          <section>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              9.2. BALISES ("TAGS") INTERNET
            </h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                K&O PHONELAB peut employer occasionnellement des balises Internet (également appelées « tags », ou balises d'action, GIF à un pixel, GIF transparents, 
                GIF invisibles et GIF un à un) et les déployer par l'intermédiaire d'un partenaire spécialiste d'analyses Web susceptible de se trouver 
                (et donc de stocker les informations correspondantes, y compris l'adresse IP de l'Utilisateur) dans un pays étranger.
              </p>
              <p>
                Ces balises sont placées à la fois dans les publicités en ligne permettant aux internautes d'accéder au Site, et sur les différentes pages de celui-ci.
              </p>
              <p>
                Cette technologie permet à K&O PHONELAB d'évaluer les réponses des visiteurs face au Site et l'efficacité de ses actions (par exemple, le nombre de fois où une page est ouverte 
                et les informations consultées), ainsi que l'utilisation de ce Site par l'Utilisateur.
              </p>
              <p>
                Le prestataire externe pourra éventuellement recueillir des informations sur les visiteurs du Site et d'autres sites Internet grâce à ces balises, 
                constituer des rapports sur l'activité du Site à l'attention de K&O PHONELAB, et fournir d'autres services relatifs à l'utilisation de celui-ci et d'Internet.
              </p>
            </div>
          </section>

        </div>

        {/* Back to site button */}
        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center space-x-2 bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <ArrowLeft size={20} />
            <span>Retour au site</span>
          </button>
        </div>
      </div>
    </div>
  );
};